import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';
import MessageUtils from "../../../../utils/MessageUtils";
import {
    LOADING,
    LOAD_OPENING_HOURS_SUCCESS,
    CLEAR_OPENING_HOURS,
    LOAD_DELIVERY_SETTINGS_SUCCESS,
    LOAD_COLLECTION_SETTINGS_SUCCESS,
    LOAD_DINEIN_SETTINGS_SUCCESS,
    LOAD_CURBSIDE_SETTINGS_SUCCESS
} from '../../../types';

export const loadOpeningHours = (restaurantId) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });

        doLoadOpeningHours(restaurantId, dispatch, getState);
    };
};

export const doLoadOpeningHours = (restaurantId, dispatch, getState, saveDataToScreen) => {
    const url = `/restaurant-settings/${restaurantId}/opening-hours`;
    // Blocks the service when called from any order type screen for restaurants
    // configured to work with time slots
    // if (getState().serviceSettingsGeneral.timeSlotBased && saveDataToScreen) return null;

    axios().get(url)
        .then(response => loadOpeningHoursSuccess(dispatch, response, saveDataToScreen))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:openingHoursActions.loadOpeningHoursFailure')));
}

const loadOpeningHoursSuccess = (dispatch, response, saveDataToScreen) => {
    dispatch({ type: LOADING, payload: false });
    let responseData = [...response.data];
    if (saveDataToScreen) {
        responseData.map(timePeriod => {
            timePeriod.duration = 60;
            timePeriod.maxOrders = 10000;
        });
    }

    if (saveDataToScreen === 'delivery') {
        dispatch({ type: LOAD_DELIVERY_SETTINGS_SUCCESS, payload: response.data });
    } else if (saveDataToScreen === 'collection') {
        dispatch({ type: LOAD_COLLECTION_SETTINGS_SUCCESS, payload: response.data });
    } else if (saveDataToScreen === 'dinein') {
        dispatch({ type: LOAD_DINEIN_SETTINGS_SUCCESS, payload: response.data });
    } else if (saveDataToScreen === 'curbside') {
        dispatch({ type: LOAD_CURBSIDE_SETTINGS_SUCCESS, payload: response.data });
    }

    dispatch({ type: LOAD_OPENING_HOURS_SUCCESS, payload: response.data });
};


export const saveOpeningHours = (state, restaurantId, callback) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant-settings/${restaurantId}/opening-hours`;
        const stateCopy = [];
        state.map(item => {
            let itemCopy = { ...item };

            delete itemCopy.duration;
            delete itemCopy.maxValue;
            delete itemCopy.maxOrders;

            stateCopy.push(itemCopy);
        });

        axios().put(url, stateCopy)
            .then(response => saveOpeningHoursSuccess(dispatch, response, restaurantId, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:openingHoursActions.saveOpeningHoursFailure')));
    };
};

const saveOpeningHoursSuccess = (dispatch, response, restaurantId, callback) => {

    const url = `/restaurant-settings/${restaurantId}/opening-hours`;
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:openingHoursActions.saveOpeningHoursSuccessMessage'));
    if (callback) {
        callback();
    }
    // axios().get(url)
    //     .then(response => loadOpeningHoursSuccess(dispatch, response, true))
    //     .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:openingHoursActions.loadOpeningHoursFailure')));

};

export const clearOpeningHours = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: CLEAR_OPENING_HOURS });
    }
};



// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/restaurant/OpeningHoursActions.js